/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  IPersonWithEmail,
  IGenericJSONMessage,
} from '../types/response.types'

export default new class CustomersAPI extends RequestHandler {
  /****** GET methods *****/
  public async get_All(
  ): Promise<IPersonWithEmail[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/customers/all`,
    })
  }
  public async get_ContactInfo(
    customer_id: any,
  ): Promise<IPersonWithEmail> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/customers/${customer_id}/contact-info`,
    })
  }
  /****** PUT methods *****/
  public async put_UpdateName(
    customer_id: any,
    name: string,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/customers/${customer_id}/name`,
      data: {
        name
      },
    })
  }
}()
